import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { StyleSheet, View, Text, Modal, TouchableOpacity, Dimensions, FlatList } from 'react-native'

import { InitialInputVoiceSearch } from '../../../../components/VoiceSearch/InitialInput/InitialInput'
import { FreshWaterContext } from '../../../../context/FreshWater/FreshWaterContext'
import { white, grayBorders, corporateColor, toqueColor } from '../../../../theme/colors'
import { AuthContext } from '../../../../context/Auth/AuthContext'
import { SeaWaterContext } from '../../../../context/SeaWater/SeaWaterContext'
import { MortalityItem } from '../../../../types'
import { MortalityItem as MortalityComponent } from './MortalityItem'
import { useTranslation } from 'react-i18next'
import { MortalityType } from '../../../../context/FreshWater/types'
import { AreaSelected } from '../../../../context/Auth/AuthReducer'

const WIDTH_SCREEN = Dimensions.get('screen').width

interface Props {
  initialValues: MortalityItem
  date: string
  levelThreeId: number
  levelThreeName: string
  name: string
  onSelectedItem: (values: MortalityItem) => void
  closeModal: () => void
}

export const TypesOfMortality = ({
  onSelectedItem,
  initialValues,
  closeModal,
  date,
  levelThreeId,
  levelThreeName,
  name,
}: Props) => {
  const {
    user: { areaSelected },
  } = useContext(AuthContext)

  const freshWaterContext = useContext(FreshWaterContext)
  const seaWaterContext = useContext(SeaWaterContext)

  const dataMap: Partial<Record<Exclude<AreaSelected, null>, MortalityType[]>> = useMemo(
    () => ({
      sweetWater: freshWaterContext.mortalityTypes,
      seaWater: seaWaterContext.mortalityTypes,
    }),
    [],
  )
  const { t } = useTranslation()
  const [selected, setSelected] = useState<Set<number>>(() => {
    const keySelected = Object.keys(initialValues)
    const moratlitysByPond = keySelected.filter((key) => key.includes(name))
    return new Set(moratlitysByPond.map((key) => initialValues[key]!.mortalityTypeId))
  })
  const [show, setShow] = useState(true)
  const [filteredData, setfilteredData] = useState<MortalityType[]>([])
  const [search, setSearch] = useState('')
  const handleSearchValue = useCallback((value: string) => setSearch(value), [])

  const handleHideModal = () => setShow(false)
  const handleSelected = useCallback(({ id, name }: { id: number; name: string }) => {
    setSelected((oldSelected) => {
      const newSelected = new Set(oldSelected)
      if (newSelected.has(id)) {
        newSelected.delete(id)
      } else {
        newSelected.add(id)
      }
      return newSelected
    })
  }, [])
  useEffect(() => {
    setfilteredData(
      dataMap[areaSelected!]!.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase()),
      ),
    )
  }, [search])

  return (
    <Modal visible={show} transparent animationType='fade' hardwareAccelerated>
      <View style={styles.container}>
        <TouchableOpacity style={styles.header} onPress={closeModal}>
          <View style={styles.close} />
          <Text style={styles.title}>{t('Selecciona el tipo de mortalidad')}</Text>
        </TouchableOpacity>
        <InitialInputVoiceSearch
          placeholder={t('BUSCAR MORTALIDAD')}
          getSearchValue={handleSearchValue}
          hasInput
        />

        <View>
          <FlatList
            style={{ height: 350, marginVertical: 50 }}
            data={filteredData}
            numColumns={2}
            keyExtractor={(item) => item.mortalityTypeId.toString()}
            renderItem={({ item }) => (
              <MortalityComponent
                item={item}
                isCheck={selected.has(item.mortalityTypeId)}
                onPress={handleSelected}
              />
            )}
          />
        </View>
        <View style={styles.footer}>
          <TouchableOpacity
            style={styles.button}
            activeOpacity={0.7}
            onPress={() => {
              const selectedItems: MortalityItem = {}
              selected.forEach((id) => {
                const key = `${levelThreeId}-${date}-${id}`
                const mortalityType = dataMap[areaSelected!]!.find(
                  (item) => item.mortalityTypeId === id,
                )
                if (mortalityType) {
                  selectedItems[key] = {
                    quantity: 0,
                    date,
                    mortalityTypeId: id,
                    levelThreeId,
                    mortalityName: mortalityType.name,
                    levelThreeName,
                    unitId: 0,
                  }
                }
              })
              onSelectedItem(selectedItems)
              handleHideModal()
            }}
          >
            <Text style={styles.textButton}>{t('Aceptar')}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  )
}
const styles = StyleSheet.create({
  container: {
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    padding: 20,
    flex: 1,
    backgroundColor: white,
  },

  header: {
    alignItems: 'center',
  },
  close: {
    borderBottomWidth: 5,
    borderBottomColor: grayBorders,
    borderRadius: 10,
    width: 50,
    marginBottom: 15,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: corporateColor,
  },

  footer: {
    alignItems: 'center',
  },

  button: {
    backgroundColor: toqueColor,
    alignItems: 'center',
    padding: 15,
    borderRadius: 10,
    width: WIDTH_SCREEN * 0.8,
  },

  textButton: {
    color: white,
    fontSize: 15,
    fontWeight: 'bold',
  },
})
